<template>
  <div id="_pg-layout">
    <modal v-show="showLogin" hide-footer size="md" id="modal-login"
           :title="this.showForgot ? $t('actions.recoverAccount') : $t('actions.login')" @close="showLogin = false">
      <template v-if="this.showForgot" #header>{{ $t('actions.recoverAccount') }}</template>
      <template v-else #header>{{ $t('actions.login') }}</template>
      <template #body>
        <login @show-register="displayRegister()" @show-login="displayLogin();this.showForgot=false"
               :forgetPassword="this.showForgot" @show-recovery="this.showForgot=true" @close-modal="showLogin = false"
               @show-edit="displayRegister()" @show-basket="displayBasket()"/>
      </template>
    </modal>
    <modal v-show="showProfile" hide-footer size="lg" id="modal-register" title="Mi perfil"
           @close="showProfile = false">
      <template #header>El meu perfil</template>
      <template #body>
        <customer-profile @back="displayProducts()" @updated="showProfile = false"/>
      </template>
    </modal>
    <modal v-if="showChangeBookings" hide-footer size="lg" id="modal-change-bookings" title="Modificar reserves"
           @close="showChangeBookings = false">
      <template #header>Modificar reserves</template>
      <template #body>
        <p>Només es poden modificar les reserves 48 hores abans de l'hora d'inici.</p>
        <change-bookings @back="displayProducts()" :filters="{'startsAt': {'gt': new Date()}}"
                         :orders="{'startsAt':'asc'}"/>
      </template>
    </modal>
    <modal v-if="showOrders" hide-footer size="lg" id="modal-orders" title="Les meves comandes"
           @close="showOrders = false">
      <template #header>Les meves comandes</template>
      <template #body>
        <MyOrders @back="displayProducts()" :orders="{'createdAt':'desc'}"/>
      </template>
    </modal>
    <modal v-show="showRegister" hide-footer size="lg" id="modal-register" title="Registro"
           @close="showRegister = false">
      <template #header>Registre</template>
      <template #body>
        <register @back="displayProducts()" @show-login="displayLogin()" @show-basket="displayBasket()"/>
      </template>
    </modal>
    <modal v-show="urlParamToken && showRecovery" hide-footer size="md" id="modal-recovery"
           @close="showRecovery = false">
      <template #header>Canvi de contrasenya</template>
      <template #body>
        <recoveryPass v-if="urlParamToken && showRecovery" :token="urlParamToken" @show-recovery="displayBasket()"
                      @show-login="showRecovery = false; displayLogin();"/>
      </template>
    </modal>
    <modal v-show="showBasket" hide-footer size="xl" id="modal-basket" @close="showBasket = false">
      <template #header>Cistella</template>
      <template #body>
        <basket @back="showBasket = false" @show-account="displayRegister();" @show-login="displayLogin()"
                @show-register="displayRegister()"/>
      </template>
    </modal>
    <modal v-show="selectedProduct != null" hide-footer size="lg" id="modal-calendar" @close="selectedProduct = null">
      <template #header>{{ $t('messages.selectBookingdate') }}</template>
      <template #body>
        <SimpleCalendar v-if="selectedProduct" :product="selectedProduct"
                        @bookingSlotSelected="handleBookingSlotSelected" @cancel="handleCancel"
                        :ref="selectedProduct.id"/>
      </template>
    </modal>
    <modal v-show="selectedGiftVoucherProduct != null" hide-footer size="lg" id="modal-gift-voucher"
           @close="selectedGiftVoucherProduct = null">
      <template #header>{{ $t('messages.giftVoucherRecipientTitle') }}</template>
      <template #body>
        <GiftVoucherRecipientForm v-if="selectedGiftVoucherProduct" :product="selectedGiftVoucherProduct"
                                  @recipient-selected="handleGiftVoucherRecipientSelected"
                                  @cancel="handleGiftVoucherCancel"/>
      </template>
    </modal>
    <modal v-show="urlParamOrderId" hide-footer size="lg" id="modal-order" @close="cancelOrder()">
      <template #header>Comanda</template>
      <template #body>
        <order v-if="urlParamOrderId" :orderId="urlParamOrderId" :paymentError="urlParamPaymentError"
               @cancel="cancelOrder"/>
      </template>
    </modal>
  </div>
</template>
<script>
import {mapActions} from 'vuex';
import basket from '@/components/castelldelremei/basket';
import login from '@/components/login';
import register from '@/components/register';
import order from '@/components/order';
import SimpleCalendar from '@/components/castelldelremei/simpleCalendar';
import GiftVoucherRecipientForm from '@/components/castelldelremei/giftVoucherRecipientForm';
import MyOrders from '@/components/myOrders';
import RecoveryPass from '@/components/recoveryPass';
import Modal from '@/components/castelldelremei/modal';
import {clone} from '@/utils/objects';
// import OrderRepository from "@/api/OrderRepository";
import CustomerProfile from "@/components/customerProfile";
import ChangeBookings from "@/components/changeBookings.vue";

export default {
  components: {
    ChangeBookings,
    CustomerProfile,
    basket,
    login,
    register,
    order,
    SimpleCalendar,
    GiftVoucherRecipientForm,
    MyOrders,
    RecoveryPass,
    Modal
  },
  data() {
    return {
      urlParamOrderId: null,
      urlParamPaymentError: null,
      urlParamToken: null,
      selectedProduct: null,
      selectedGiftVoucherProduct: null,
      showBasket: false,
      showLogin: false,
      showRegister: false,
      showProfile: false,
      showOrders: false,
      showChangeBookings: false,
      showRecovery: true,
      showForgot: false,
      // Sistema de configuración de productos (soporta packs anidados)
      configurationQueue: [], // Cola plana de items a configurar {type: 'bookable'|'gift_recipient', product, path: [indices]}
      currentConfigIndex: 0,
      productBeingConfigured: null, // El producto raíz (puede ser pack o producto simple)
      configuredData: {}, // Almacena las configuraciones por path
      sharedGiftRecipient: null, // Recipient compartido para todos los items bookable_gift
      hasGiftProducts: false // Flag para saber si hay productos gift en el flujo
    };
  },
  computed: {
    showProducts() {
      return !this.showBasket && !this.selectedProduct && !this.showLogin && !this.showRegister && !this.showProfile && !this.showOrders && !this.showChangeBookings && !this.showRecovery;
    }
  },
  created() {

    console.log('created castellDelRemei.vue');

    window.addEventListener('bambuyo:close-all', (event) => {
      console.log(event);
      this.closeAll();
    });

    window.addEventListener('bambuyo:login', (event) => {
      console.log(event);
      this.showLogin = !this.showLogin;
    });

    window.addEventListener('bambuyo:basket', (event) => {
      console.log(event);
      this.showBasket = true;
    });

    window.addEventListener('bambuyo:profile', (event) => {
      console.log(event);
      this.showProfile = true;
    });

    window.addEventListener('bambuyo:recovery-pass', (event) => {
      console.log(event);
      this.showRecovery = true;
      this.urlParamToken = localStorage.getItem('token');
    });

    window.addEventListener('bambuyo:my-orders', (event) => {
      console.log(event);
      this.displayOrders();
    });

    window.addEventListener('bambuyo:change-bookings', (event) => {
      console.log(event);
      this.displayChangeBookings();
    });

    window.addEventListener('bambuyo:add-product', (event) => {
      console.log(event);
      const product = event.detail.product;

      // Lógica especial para Castell del Remei: booking automático para producto solidario
      if (product.type === 'bookable' && product.name === 'Aportació solidària') {
        product.booking = {
          "startsAt": "2025-03-21T18:00:00.000000Z",
        };
        this.addProduct(product);
        this.showBasket = true;
        return;
      }

      this.startProductConfiguration(product);
    });

    let re = new RegExp(/orderId=([\w-]+)/);
    if (re.test(location.hash)) {
      this.urlParamOrderId = re.exec(location.hash)[1];
    }

    re = new RegExp(/paymentError=([\w_]+)/);
    if (re.test(location.hash)) {
      this.urlParamPaymentError = re.exec(location.hash)[1];
    }

    re = new RegExp(/login=([\w_.-]+)/);
    if (re.test(location.hash)) {
      this.logout();
      this.autoLogin(re.exec(location.hash)[1]);
    }

    re = new RegExp(/token=([\w_.-]+)/);
    if (re.test(location.hash)) {
      this.urlParamToken = re.exec(location.hash)[1];
    }
  },
  methods: {
    ...mapActions('basket', ['addProduct']),
    ...mapActions('session', ['logout', 'autoLogin']),
    async cancelOrder() {
      if (this.urlParamPaymentError) {
        // await OrderRepository.delete(this.urlParamOrderId);
      }
      window.location.hash = '';
      this.urlParamOrderId = null;
      this.urlParamPaymentError = null;
      window.dispatchEvent(new CustomEvent('bambuyo:basket'));
    },
    handleBookingSlotSelected(slot) {
      console.log('🔍 Booking slot selected:', slot);

      const currentItem = this.configurationQueue[this.currentConfigIndex];
      if (!currentItem) {
        console.error('No current item in configuration queue');
        return;
      }

      // Guardar la configuración del booking
      this.configuredData[currentItem.path.join('.')] = {
        type: 'booking',
        booking: slot
      };

      // Avanzar a la siguiente configuración
      this.reset();
      this.currentConfigIndex++;
      this.processNextConfiguration();
    },
    handleCancel() {
      console.log('🔍 Configuration cancelled');
      this.resetConfiguration();
    },
    handleGiftVoucherRecipientSelected(recipientData) {
      console.log('🔍 Gift voucher recipient selected:', recipientData);

      if (recipientData) {
        // Guardar el recipient compartido para todos los items gift
        this.sharedGiftRecipient = recipientData;
      }

      // Avanzar a la siguiente configuración
      this.resetGiftVoucher();
      this.currentConfigIndex++;
      this.processNextConfiguration();
    },
    handleGiftVoucherCancel() {
      console.log('🔍 Gift voucher configuration cancelled');
      this.resetConfiguration();
    },
    reset() {
      this.selectedProduct = null;
    },
    resetGiftVoucher() {
      this.selectedGiftVoucherProduct = null;
    },
    closeAll() {
      this.showBasket = false;
      this.showLogin = false;
      this.showRegister = false;
      this.showProfile = false;
      this.showOrders = false;
      this.showChangeBookings = false;
      this.showRecovery = false;
    },
    displayLogin() {
      this.closeAll();
      this.showLogin = true;
    },
    displayRegister() {
      this.closeAll();
      this.showRegister = true;
    },
    displayBasket() {
      this.closeAll();
      this.showBasket = true;
    },
    displayProducts() {
      this.closeAll();
      this.showProducts = true;
    },
    displayOrders() {
      this.closeAll();
      this.showOrders = true;
    },
    displayChangeBookings() {
      this.closeAll();
      this.showChangeBookings = true;
    },

    // ============================================
    // NUEVO SISTEMA DE CONFIGURACIÓN DE PRODUCTOS
    // ============================================

    /**
     * Punto de entrada para configurar cualquier producto
     * Maneja productos simples y packs (anidados o no)
     */
    startProductConfiguration(product) {
      console.log('🚀 Starting product configuration for:', product);

      // Resetear estado anterior
      this.resetConfiguration();

      // Guardar el producto raíz
      this.productBeingConfigured = clone(product);

      // Construir la cola de configuraciones necesarias
      this.buildConfigurationQueue(this.productBeingConfigured, []);

      console.log('📋 Configuration queue built:', this.configurationQueue);

      // Si no hay nada que configurar, añadir directamente al carrito
      if (this.configurationQueue.length === 0) {
        console.log('✅ No configuration needed, adding to basket');
        this.addProduct(this.productBeingConfigured);
        this.showBasket = true;
        return;
      }

      // Comenzar el proceso de configuración
      this.currentConfigIndex = 0;
      this.processNextConfiguration();
    },

    /**
     * Construye recursivamente la cola de configuraciones
     * Explora el árbol de productos y detecta qué necesita configurarse
     */
    buildConfigurationQueue(product, path) {
      // Si es un producto bookable, necesita configuración de booking
      if (product.type === 'bookable') {
        this.configurationQueue.push({
          type: 'bookable',
          product: product,
          path: [...path]
        });
      }

      // Si es bookable_gift, credit o credit_subscription, necesita recipient
      if (['bookable_gift', 'credit', 'credit_subscription'].includes(product.type)) {
        // Marcar que hay productos gift en el flujo
        this.hasGiftProducts = true;

        // Solo añadir UNA configuración de gift recipient para todo el flujo
        const alreadyHasGiftConfig = this.configurationQueue.some(item => item.type === 'gift_recipient');
        if (!alreadyHasGiftConfig) {
          this.configurationQueue.push({
            type: 'gift_recipient',
            product: product,
            path: [...path]
          });
        }
      }

      // Si es un pack, explorar recursivamente sus items
      if (product.type === 'pack' && product.packItems && product.packItems.length > 0) {
        product.packItems.forEach((packItem, index) => {
          if (packItem.childProduct) {
            const itemPath = [...path, 'packItems', index];
            this.buildConfigurationQueue(packItem.childProduct, itemPath);
          }
        });
      }
    },

    /**
     * Procesa la siguiente configuración en la cola
     */
    processNextConfiguration() {
      console.log(`🔄 Processing configuration ${this.currentConfigIndex + 1}/${this.configurationQueue.length}`);

      // Si hemos terminado todas las configuraciones
      if (this.currentConfigIndex >= this.configurationQueue.length) {
        console.log('✅ All configurations completed');
        this.finalizeProductConfiguration();
        return;
      }

      const currentItem = this.configurationQueue[this.currentConfigIndex];
      console.log('📝 Current item to configure:', currentItem);

      // Mostrar el modal correspondiente según el tipo
      if (currentItem.type === 'bookable') {
        this.selectedProduct = currentItem.product;
      } else if (currentItem.type === 'gift_recipient') {
        this.selectedGiftVoucherProduct = currentItem.product;
      }
    },

    /**
     * Finaliza la configuración y construye el producto final con todas las configuraciones aplicadas
     */
    finalizeProductConfiguration() {
      console.log('🏁 Finalizing product configuration');
      console.log('📊 Configured data:', this.configuredData);

      // Aplicar las configuraciones al producto
      const finalProduct = this.applyConfigurationsToProduct(
        clone(this.productBeingConfigured),
        []
      );

      console.log('✅ Final product:', finalProduct);

      // Resetear estado
      this.resetConfiguration();

      // Añadir al carrito
      this.addProduct(finalProduct);
      this.showBasket = true;
    },

    /**
     * Aplica recursivamente las configuraciones guardadas al producto
     */
    applyConfigurationsToProduct(product, path) {
      const pathKey = path.join('.');

      // Aplicar configuración de booking si existe
      const bookingConfig = this.configuredData[pathKey];
      if (bookingConfig && bookingConfig.type === 'booking') {
        product.booking = bookingConfig.booking;
      }

      // Aplicar recipient compartido si es producto gift
      if (['bookable_gift', 'credit', 'credit_subscription'].includes(product.type) && this.sharedGiftRecipient) {
        product.giftVoucherRecipient = this.sharedGiftRecipient;
      }

      // Si es un pack, procesar recursivamente sus items
      if (product.type === 'pack' && product.packItems && product.packItems.length > 0) {
        product.packItems = product.packItems.map((packItem, index) => {
          if (packItem.childProduct) {
            const itemPath = [...path, 'packItems', index];
            const configuredChild = this.applyConfigurationsToProduct(
              clone(packItem.childProduct),
              itemPath
            );

            // Construir el objeto packItem según el formato de la API
            const result = {
              id: packItem.id,
              quantity: packItem.quantity,
              childProduct: {
                id: configuredChild.id
              }
            };

            // Añadir bookingCalendarId si existe
            if (configuredChild.bookingCalendarId) {
              result.childProduct.bookingCalendarId = configuredChild.bookingCalendarId;
            }

            // Añadir booking si existe
            if (configuredChild.booking) {
              result.childProduct.booking = {
                bookingCalendarId: configuredChild.bookingCalendarId,
                startsAt: configuredChild.booking.startDate,
                notes: ''
              };
            }

            // Añadir giftVoucherRecipient si existe
            if (configuredChild.giftVoucherRecipient) {
              result.childProduct.giftVoucherRecipient = configuredChild.giftVoucherRecipient;
            }

            return result;
          }
          return packItem;
        });

        // Si hay productos gift en el flujo, añadir el recipient a nivel de pack también
        if (this.hasGiftProducts && this.sharedGiftRecipient) {
          product.giftVoucherRecipient = this.sharedGiftRecipient;
        }
      }

      return product;
    },

    /**
     * Resetea todo el estado de configuración
     */
    resetConfiguration() {
      console.log('🔄 Resetting configuration state');
      this.configurationQueue = [];
      this.currentConfigIndex = 0;
      this.productBeingConfigured = null;
      this.configuredData = {};
      this.sharedGiftRecipient = null;
      this.hasGiftProducts = false;
      this.selectedProduct = null;
      this.selectedGiftVoucherProduct = null;
    }
  },
}
</script>
<style>
div#_pg-app {
  padding: 0 !important;
}

.link {
  cursor: pointer;
}

.st-link {
  cursor: pointer;
  text-decoration: underline;
}
</style>
